export default __webpack_public_path__ + "static/media/spec.26de63d2.yaml";